import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

export const Panel: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box
    borderWidth="1px"
    borderColor="gray.200"
    borderRadius="md"
    bg="white"
    shadow="sm"
    {...props}
  >
    {children}
  </Box>
);

export const PanelHeader: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box px={4} py={3} borderBottom="1px solid" borderColor="gray.100" {...props}>
    {children}
  </Box>
);

export const PanelBody: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box px={4} py={4} {...props}>
    {children}
  </Box>
);
